import type { Space } from '@/api/generated/models';

export interface SpaceNode extends Space {
  children: SpaceNode[];
}

export const buildTree = (spaces: Space[]): SpaceNode[] => {
  const nodes = new Map<string, SpaceNode>();
  spaces.forEach((space) => {
    if (space.id) nodes.set(space.id, { ...space, children: [] });
  });
  const roots: SpaceNode[] = [];
  nodes.forEach((node) => {
    if (node.parentSpaceId && nodes.has(node.parentSpaceId)) {
      nodes.get(node.parentSpaceId)!.children.push(node);
    } else {
      roots.push(node);
    }
  });
  return roots;
};
